import css from 'styled-jsx/css';
import { zIndex } from '../../../config/styles';

const styles = css`
  .mobile-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    z-index: ${zIndex.MobileFullscreenModal.modal};
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .mobile-modal-header {
    display: flex;
    align-items: center;
    position: relative;
    padding: 16px;
    border-bottom: 1px solid #eee;
  }

  .mobile-modal-title {
    flex: 1;
    text-align: center;
    margin: 0;
    font-size: 18px;
    color: #333;
    font-weight: 700;
    font-family: Lato, sans-serif;
    font-style: normal;
    line-height: 20px;
  }

  .mobile-modal-close {
    position: absolute;
    right: 16px;
    font-size: 28px;
    cursor: pointer;
  }

  .mobile-modal-content {
    flex: 1;
    overflow: auto;
    padding-bottom: 16px;
  }
`;

export default styles;
